"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var WatchStatus;
(function (WatchStatus) {
    WatchStatus["Unwatched"] = "unwatched";
    WatchStatus["Watching"] = "watching";
    WatchStatus["Watched"] = "watched";
})(WatchStatus = exports.WatchStatus || (exports.WatchStatus = {}));
//# sourceMappingURL=WatchStatus.js.map